export const introduce = {
  text: '转入交易所地址的代币总数',
  height: 1200,
};
